var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgToday(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_576_2905)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19 3.5H18V2.5C18 1.95 17.55 1.5 17 1.5C16.45 1.5 16 1.95 16 2.5V3.5H8V2.5C8 1.95 7.55 1.5 7 1.5C6.45 1.5 6 1.95 6 2.5V3.5H5C3.89 3.5 3.01 4.4 3.01 5.5L3 19.5C3 20.6 3.89 21.5 5 21.5H19C20.1 21.5 21 20.6 21 19.5V5.5C21 4.4 20.1 3.5 19 3.5ZM18 19.5H6C5.45 19.5 5 19.05 5 18.5V8.5H19V18.5C19 19.05 18.55 19.5 18 19.5ZM8 10.5H11C11.55 10.5 12 10.95 12 11.5V14.5C12 15.05 11.55 15.5 11 15.5H8C7.45 15.5 7 15.05 7 14.5V11.5C7 10.95 7.45 10.5 8 10.5Z",
    fill: "#1C1C1C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_576_2905"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToday);
export default __webpack_public_path__ + "static/media/today.40f9082abde787ecd1a11bb27d9efae9.svg";
export { ForwardRef as ReactComponent };